module.exports = __webpack_public_path__ + "static/ForTheKing3-e48134040b1141d34489ef5aae4c5cf5.png";